import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { readPublicEnvironment } from "./env";
import type { Database } from "./types/database.generated";

export type SupabaseClientResult =
  | { ok: true; client: SupabaseClient<Database> }
  | { ok: false; message: string };

let cachedClient: SupabaseClient<Database> | undefined;

export function getSupabaseClient(): SupabaseClientResult {
  const environment = readPublicEnvironment();
  if (!environment.ok) return environment;

  cachedClient ??= createClient<Database>(
    environment.value.supabaseUrl,
    environment.value.supabasePublishableKey,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    },
  );

  return { ok: true, client: cachedClient };
}
